var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { SpaceRecentListApi } from './apis/space-recent-list-api.interface';
let SpaceRecentListRepositoryImpl = class SpaceRecentListRepositoryImpl {
    constructor(_spaceRecentListApi) {
        this._spaceRecentListApi = _spaceRecentListApi;
    }
    async getRecentList() {
        const res = await this._spaceRecentListApi.getRecentList();
        const result = res.map((item) => ({
            spaceId: item.space_id,
            spaceName: item.space_name,
        }));
        return result;
    }
};
SpaceRecentListRepositoryImpl = __decorate([
    injectable(),
    __param(0, inject(SpaceRecentListApi)),
    __metadata("design:paramtypes", [typeof (_a = typeof SpaceRecentListApi !== "undefined" && SpaceRecentListApi) === "function" ? _a : Object])
], SpaceRecentListRepositoryImpl);
export { SpaceRecentListRepositoryImpl };
